import "core-js/modules/es6.function.name";
// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import flatten from 'lodash/flatten';
import Details from './details';
import BottomLine from './bottomLine';

var getIcon = function getIcon(name) {
  try {
    return iconUri(name);
  } catch (e) {
    return null;
  }
};

var ProductDetails = function ProductDetails(_ref) {
  var data = _ref.data,
      reviewTarget = _ref.reviewTarget;
  var product = data;
  var bottomLine = React.createElement(BottomLine, {
    bottomLineText: data.quote || data.bottomLine,
    reviewLink: product.review,
    reviewTarget: reviewTarget
  });
  var bestForTitle = "".concat(product.name, " is best for");
  var columns = {
    left: {
      title: 'Pros',
      icon: getIcon('Thumbs_up'),
      details: data.pros
    },
    middle: {
      title: 'Cons',
      icon: getIcon('Thumbs_down'),
      details: data.cons
    },
    right: {
      title: bestForTitle,
      details: flatten([data.bestFor])
    }
  };
  return React.createElement("div", {
    className: "product-details"
  }, React.createElement("div", {
    className: "bottom-line"
  }, bottomLine), React.createElement("div", {
    className: "product-details-content-wrapper"
  }, ['left', 'middle', 'right'].map(function (colName) {
    var column = columns[colName];
    return React.createElement(Details, {
      key: colName,
      title: column.title,
      review: column.details
    });
  })));
};

ProductDetails.displayName = 'ProductDetails';
ProductDetails.propTypes = {
  data: PropTypes.object,
  quote: PropTypes.string,
  reviewTarget: PropTypes.string
};
export default ProductDetails;